export enum SalaryChangeType {
  MANUAL = "manual",
  SALARY_REQUEST = "salary_request",
  SYSTEM = "system",
}

export interface ISalaryPricingChange {
  pricingId: string;
  forName: string;
  oldPerUnit?: number;
  newPerUnit?: number;
  oldPerMonth?: number;
  newPerMonth?: number;
  oldQuantity?: number;
  newQuantity?: number;
}

export interface ISalaryPricingLog {
  _id: string;
  salaryId: string;
  workerId: string;
  workerName: string;
  workerSurname?: string;
  salaryType: string;
  salaryCurrency: string;
  changes: ISalaryPricingChange[];
  totalOldSalary: number;
  totalNewSalary: number;
  salaryDifference: number;
  reason: string;
  changeType: SalaryChangeType;
  relatedRequestId?: {
    _id: string;
    month: string;
    status: string;
    notes?: string;
    approvalNotes?: string;
    rejectionReason?: string;
  };
  changedBy: {
    _id: string;
    username: string;
  };
  changedByName: string;
  previousDebt?: number;
  newDebt?: number;
  debtDifference?: number;
  createdAt: string;
  updatedAt: string;
}

export interface ISalaryPricingStats {
  overallStats: {
    totalChanges: number;
    totalSalaryIncrease: number;
    totalSalaryDecrease: number;
    totalDebtIncrease: number;
    totalDebtDecrease: number;
    avgSalaryChange: number;
    avgDebtChange: number;
  };
  changeTypeStats: Array<{
    changeType: string;
    count: number;
    totalSalaryChange: number;
    totalDebtChange: number;
  }>;
} 